module.exports = __webpack_public_path__ + "static/media/Q12-1.4371752e.png";